import { dataPauseCircleSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPauseCircleSolid = /*#__PURE__*/createIcon(dataPauseCircleSolid)
export default IconPauseCircleSolid
